export const SET_MAHNSTUFE_STATI = "setMahnstufeStati";
export const SET_ZAHLUNG_STATI = "setZahlungStati";
export const SET_BUCHUNG_STATI = "setBuchungsStati";
export const SET_ZAHLUNGSPLAENE = "setZahlungsplaene";